import { formatCamelCaseToSentenceCase, formatTextToCamelCase } from "oolib"
import { createContentCardDate } from "../../../../../../utils/momentManipulate";
import { getTplTitle } from "../../../../../../utils/general";
import { queryClient } from "../../../../../..";


const getRoleDisplay = role => {
    const {allRoles} = queryClient.getQueryData('platformConfigs') || {};
    if(!allRoles) return role;
    //else
    return allRoles.find(r => r.value === role)?.display || role
}

const getProfileTypeDisplay = profileType => {
    const allTpls = queryClient.getQueryData('allTpls');
    return allTpls.find(p => p.kp_content_type === profileType)?.general?.content?.title || profileType
}

export const formatters = {
    formatCamelCaseToSentenceCase,
    formatTextToCamelCase,
    createContentCardDate,
    // Read when called, not when this module loads: utils/general imports the
    // app's root index (for queryClient), which loads the app, which reaches
    // this module — so at load time getTplTitle may not be initialised yet.
    getTplTitle: (...args) => getTplTitle(...args),
    getRoleDisplay,
    getProfileTypeDisplay
}